import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../../components/buttons/Button';
import Icon from '../../../components/icons/Icon';
import TemplateButton from './BoardTemplatePickerBodyListingTemplateButton';

import { getTemplateId, getTemplateIsCustom, EMPTY_BOARD_TEMPLATE } from '../boardTemplatePickerUtil';

import './BoardTemplatePickerBodyDefault.scss';

const BoardTemplatePickerDefault = ({
    currentBoard,
    selectedTemplateId,
    templates,
    defaultTemplateListing,
    selectTemplate,
    handleCloseButton,
    setNavigation,
}) => (
    <div className="picker-body PickerBodyDefault">
        <ul className="picker-templates">
            <li>
                <TemplateButton
                    templateEntry={EMPTY_BOARD_TEMPLATE}
                    templates={templates}
                    selectedTemplateId={selectedTemplateId}
                    selectTemplate={selectTemplate}
                />
            </li>
        </ul>

        <ul className="picker-templates">
            {defaultTemplateListing.map((templateEntry, index) => (
                <li key={getTemplateId(templateEntry)}>
                    <TemplateButton
                        templateEntry={templateEntry}
                        templates={templates}
                        isTopPick={index === 0}
                        isCustomTemplate={getTemplateIsCustom(templateEntry)}
                        selectedTemplateId={selectedTemplateId}
                        selectTemplate={selectTemplate}
                    />
                </li>
            ))}
        </ul>

        <Button className="picker-more-button" onClickFn={() => setNavigation('categories')}>
            <span>More templates...</span>
            <Icon name="chevron-left" className="nav-right" />
        </Button>
    </div>
);

BoardTemplatePickerDefault.propTypes = {
    currentBoard: PropTypes.object,
    selectedTemplateId: PropTypes.string,
    navigation: PropTypes.string,
    templates: PropTypes.object,
    defaultTemplateListing: PropTypes.object,
    templateCollections: PropTypes.object,
    selectTemplate: PropTypes.func,
    handleCloseButton: PropTypes.func,
    setNavigation: PropTypes.func,
};

export default BoardTemplatePickerDefault;
